export default "__VITE_ASSET__CMrDueBE__"